/**
 * @generated SignedSource<<ec02410682d64c97cf135592b124730c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuickViewCreatorsV2_quickViewDisplay$data = {
  readonly creators: ReadonlyArray<{
    readonly displayName: string;
    readonly linkData: {
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
  } | null> | null;
  readonly " $fragmentType": "QuickViewCreatorsV2_quickViewDisplay";
};
export type QuickViewCreatorsV2_quickViewDisplay$key = {
  readonly " $data"?: QuickViewCreatorsV2_quickViewDisplay$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuickViewCreatorsV2_quickViewDisplay">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuickViewCreatorsV2_quickViewDisplay",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QuickViewDisplayType",
  "abstractKey": null
};

(node as any).hash = "00828d11fa5f159c00b3cea80e4e52e7";

export default node;
